import { EpiPage } from '@api/types';
import { CategoryPageContent, ProductPageContent, StandardPageContent } from '@components';
import { getPageContentType } from '@utils/content.utils';

export type AdditionalPageContentProps = {
  page?: EpiPage;
};

export const AdditionalPageContent = ({ page }: AdditionalPageContentProps) => {
  const pageType = getPageContentType(page);
  switch (pageType) {
    case 'Category':
      return <CategoryPageContent page={page} />;
    case 'Variation':
      return <ProductPageContent page={page} />;
    case 'HomePage':
    case 'ContentPage':
    default:
      return <StandardPageContent page={page} />;
  }
};
